import React from "react";
import { Navbar, Footer } from "../../components";
import FotoHeader from "../../assets/2FotoPabrik.jpeg";
import Aplikasi from "../../components/Lowongan/StockAdmin.jsx";
import { Header } from "../../components/CoilAbuPage.jsx";

const StockAdmin = () => {
  const BgHeader = {
    backgroundImage: `url(${FotoHeader})`,
    backgroundSize: "cover",
    backgroundPosition: "0% 60%",
    overflow: "hidden",
  };
  return (
    <>
      <Navbar />

      <section className="lg:mt-9">
        <Aplikasi />
      </section>
      <Footer />
    </>
  );
};

export default StockAdmin;
